function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLibraryBookSvgrepoCom({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 511.992 511.992",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M362.65,511.992c-5.89,0-10.655-4.781-10.655-10.656v-21.344c0-5.891,4.766-10.656,10.655-10.656 c5.891,0,10.672,4.766,10.672,10.656v21.344C373.322,507.211,368.541,511.992,362.65,511.992z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M501.32,511.992c-5.891,0-10.672-4.781-10.672-10.656v-21.344c0-5.891,4.781-10.656,10.672-10.656 s10.671,4.766,10.671,10.656v21.344C511.991,507.211,507.211,511.992,501.32,511.992z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F4545"
    },
    d: "M490.648,426.65H373.322c-5.891,0-10.672-4.766-10.672-10.656s4.781-10.656,10.672-10.656h117.326 c5.891,0,10.672,4.766,10.672,10.656S496.539,426.65,490.648,426.65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F4545"
    },
    d: "M490.648,341.34H373.322c-5.891,0-10.672-4.781-10.672-10.688c0-5.875,4.781-10.656,10.672-10.656 h117.326c5.891,0,10.672,4.781,10.672,10.656C501.32,336.558,496.539,341.34,490.648,341.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F4545"
    },
    d: "M490.648,255.996H373.322c-5.891,0-10.672-4.773-10.672-10.664s4.781-10.672,10.672-10.672h117.326 c5.891,0,10.672,4.781,10.672,10.672S496.539,255.996,490.648,255.996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F4545"
    },
    d: "M490.648,170.662H373.322c-5.891,0-10.672-4.773-10.672-10.664s4.781-10.664,10.672-10.664h117.326 c5.891,0,10.672,4.773,10.672,10.664S496.539,170.662,490.648,170.662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F4545"
    },
    d: "M490.648,85.335H373.322c-5.891,0-10.672-4.781-10.672-10.672s4.781-10.664,10.672-10.664h117.326 c5.891,0,10.672,4.773,10.672,10.664S496.539,85.335,490.648,85.335z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F4545"
    },
    d: "M32,511.992c-5.891,0-10.672-4.781-10.672-10.656v-21.344c0-5.891,4.781-10.656,10.672-10.656 s10.656,4.766,10.656,10.656v21.344C42.656,507.211,37.891,511.992,32,511.992z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F4545"
    },
    d: "M309.324,511.992c-5.891,0-10.672-4.781-10.672-10.656v-21.344c0-5.891,4.781-10.656,10.672-10.656 s10.672,4.765,10.672,10.656v21.344C319.996,507.211,315.215,511.992,309.324,511.992z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.657,
    y: 10.664,
    style: {
      fill: "#7F4545"
    },
    width: 319.99,
    height: 469.33
  })), /*#__PURE__*/React.createElement("rect", {
    x: 127.996,
    y: 266.656,
    style: {
      fill: "#48CFAD"
    },
    width: 85.33,
    height: 42.68
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.996,
    y: 31.996,
    style: {
      fill: "#FFCE54"
    },
    width: 42.655,
    height: 85.33
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#965353"
    },
    d: "M330.651,0H10.657C4.766,0,0.001,4.773,0.001,10.664v469.328c0,5.891,4.766,10.656,10.656,10.656 h319.994c5.891,0,10.672-4.766,10.672-10.656V10.664C341.323,4.774,336.542,0,330.651,0z M21.328,138.662h298.668v95.999H21.328 V138.662z M21.328,255.996h298.668v95.998H21.328V255.996z M319.996,21.336v95.998H21.328V21.336H319.996z M21.328,469.336v-95.998 h298.668v95.998L21.328,469.336L21.328,469.336z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.996,
    y: 266.656,
    style: {
      fill: "#48CFAD"
    },
    width: 42.656,
    height: 85.33
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 213.326,
    y: 266.656,
    style: {
      fill: "#ED5564"
    },
    width: 42.671,
    height: 85.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.326,
    y: 149.336,
    style: {
      fill: "#ED5564"
    },
    width: 42.671,
    height: 85.33
  })), /*#__PURE__*/React.createElement("rect", {
    x: 127.996,
    y: 149.336,
    style: {
      fill: "#5D9CEC"
    },
    width: 42.655,
    height: 85.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.656,
    y: 149.336,
    style: {
      fill: "#A0D468"
    },
    width: 42.671,
    height: 85.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.996,
    y: 31.996,
    style: {
      fill: "#AC92EB"
    },
    width: 42.656,
    height: 85.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.656,
    y: 74.666,
    style: {
      fill: "#A0D468"
    },
    width: 85.34,
    height: 42.671
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.656,
    y: 32.735,
    style: {
      fill: "#ED5564"
    },
    width: 85.34,
    height: 42.663
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 94.656,
    y: 149.336,
    style: {
      fill: "#E6E9ED"
    },
    width: 24,
    height: 85.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.326,
    y: 31.996,
    style: {
      fill: "#E6E9ED"
    },
    width: 24,
    height: 85.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.326,
    y: 31.996,
    style: {
      fill: "#E6E9ED"
    },
    width: 24,
    height: 85.33
  })), /*#__PURE__*/React.createElement("rect", {
    x: 42.656,
    y: 426.646,
    style: {
      fill: "#ED5564"
    },
    width: 85.34,
    height: 42.686
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 42.656,
    y: 435.996,
    style: {
      fill: "#E6E9ED"
    },
    width: 85.34,
    height: 23.998
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.996,
    y: 275.996,
    style: {
      fill: "#E6E9ED"
    },
    width: 85.33,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.656,
    y: 83.996,
    style: {
      fill: "#E6E9ED"
    },
    width: 85.34,
    height: 24
  })), /*#__PURE__*/React.createElement("rect", {
    x: 213.326,
    y: 31.996,
    style: {
      fill: "#5D9CEC"
    },
    width: 42.671,
    height: 85.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.656,
    y: 31.996,
    style: {
      fill: "#ED5564"
    },
    width: 42.671,
    height: 85.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.656,
    y: 149.336,
    style: {
      fill: "#48CFAD"
    },
    width: 42.672,
    height: 85.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.326,
    y: 191.996,
    style: {
      fill: "#FFCE54"
    },
    width: 85.33,
    height: 42.663
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.326,
    y: 149.336,
    style: {
      fill: "#ED5564"
    },
    width: 85.33,
    height: 42.664
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.656,
    y: 266.656,
    style: {
      fill: "#FFCE54"
    },
    width: 42.672,
    height: 85.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.326,
    y: 266.656,
    style: {
      fill: "#AC92EB"
    },
    width: 42.671,
    height: 85.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.996,
    y: 309.336,
    style: {
      fill: "#A0D468"
    },
    width: 85.33,
    height: 42.654
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.996,
    y: 383.996,
    style: {
      fill: "#FFCE54"
    },
    width: 42.656,
    height: 85.34
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.996,
    y: 383.996,
    style: {
      fill: "#5D9CEC"
    },
    width: 42.655,
    height: 85.34
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.656,
    y: 383.996,
    style: {
      fill: "#AC92EB"
    },
    width: 42.671,
    height: 85.34
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.326,
    y: 383.996,
    style: {
      fill: "#48CFAD"
    },
    width: 42.671,
    height: 85.34
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.656,
    y: 383.996,
    style: {
      fill: "#A0D468"
    },
    width: 85.34,
    height: 42.656
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#965353"
    },
    d: "M373.322,511.992c-5.891,0-10.672-4.781-10.672-10.656V10.664C362.65,4.773,367.431,0,373.322,0 c5.89,0,10.671,4.773,10.671,10.664v490.672C383.993,507.211,379.212,511.992,373.322,511.992z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#965353"
    },
    d: "M490.648,511.992c-5.891,0-10.656-4.781-10.656-10.656V10.664C479.992,4.773,484.758,0,490.648,0 s10.672,4.773,10.672,10.664v490.672C501.32,507.211,496.539,511.992,490.648,511.992z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 213.326,
    y: 158.666,
    style: {
      fill: "#E6E9ED"
    },
    width: 85.33,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.996,
    y: 318.656,
    style: {
      fill: "#E6E9ED"
    },
    width: 85.33,
    height: 23.998
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.996,
    y: 266.656,
    style: {
      fill: "#E6E9ED"
    },
    width: 24,
    height: 85.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.996,
    y: 383.996,
    style: {
      fill: "#E6E9ED"
    },
    width: 23.999,
    height: 85.34
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.656,
    y: 383.996,
    style: {
      fill: "#E6E9ED"
    },
    width: 23.999,
    height: 85.34
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.326,
    y: 383.996,
    style: {
      fill: "#E6E9ED"
    },
    width: 24,
    height: 85.34
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibraryBookSvgrepoCom);
export default __webpack_public_path__ + "static/media/library-book-svgrepo-com.9c422512656299ef28e4e1ac56eaec52.svg";
export { ForwardRef as ReactComponent };